import { CategoryModel } from "@app/catalog";

export class CategoryUpdatedMessage {
    public category: CategoryModel;
    
    constructor(category: CategoryModel)
    {
        this.category = category;
    }
}